import React from "react";

import "./ProjectContainer.css";
import { useTranslation } from "react-i18next";

type ProjectContainerProps = {
  text: string;
  imageSrc: string;
  altText?: string;
  newPageURL?: string; // Optional prop for a new page URL
};

const ProjectContainer: React.FC<ProjectContainerProps> = ({
  text,
  imageSrc,
  altText = "",
  newPageURL,
}) => {
  const { t } = useTranslation() as { t: (key: string) => string };

  return (
    <div className="projectContainer">
      <a href={newPageURL} target="_blank" rel="noopener noreferrer">
        <img src={imageSrc} alt={altText} />
        <div className="projectContainer_text_container">
          <p className="projectContainer_text">{text}</p>
        </div>
      </a>
    </div>
  );
};

export default ProjectContainer;
